
<!-- <template>
<div>
<h3 class="center">En Proceso</h3>
 


<v-progress-circular
      indeterminate
      color="grey darken-3"
    ></v-progress-circular>

     </div>  
</template> -->


<template>
  <v-container fluid>
    <v-row>

      <v-col cols="2" md="2"></v-col>

      <!-- Columna normal con el Card -->
      <v-col cols="8" md="8">
        <v-card class="pa-5" elevation="4" shaped>
          <v-card-title class="headline font-weight-bold text-center mb-4">
            Sobre TecZoa
          </v-card-title>

          <v-card-text class="subtitle-1 text-justify">
            En un mundo donde las conexiones lo son todo, 
            <strong>TecZoa nace como un puente entre emprendedores, creadores y soñadores</strong>. 
            Creemos en el poder de las ideas compartidas, en el valor de cada proyecto que empieza con pasión 
            y en la fuerza de una comunidad unida por el deseo de crecer juntos.
          </v-card-text>

          <v-divider class="my-4"></v-divider>

          <v-list dense>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary">mdi-account-star</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <strong>Creador de contenido</strong>Abierto a nuevas alianzas y colaboraciones a través de redes sociales
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary">mdi-lightbulb-on-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <strong>Emprendedor paraguayo</strong>Con la visión de transformar ideas en realidades que impacten
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary">mdi-laptop</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <strong>Desarrollador Web en TecZoa.com</strong>Una plataforma creada para que el talento y la colaboración no tengan fronteras
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary">mdi-school</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <strong>Talleres y cursos exclusivos en la modalidad en línea y presenciales</strong>Ofrecidos por TecZoa y afiliados, para fomentar el aprendizaje práctico y las comunidades de innovación locales.
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <v-divider class="my-4"></v-divider>

          <v-card-text class="text-center font-italic">
            Aquí no solo compartimos enlaces, compartimos propósitos.  
            <br><strong class="primary--text">Bienvenido a la red donde cada conexión puede ser el comienzo de algo grande.</strong>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>







<script>
export default { 
}
</script>


